import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-recharge",
  "use": "icon-recharge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-recharge\"><defs><style type=\"text/css\"></style></defs><path d=\"M273.28 583.296l0 57.28 210.048 0 0 152.768 0 0 0 0 0 38.208 57.28 0 0-38.208 0 0 0 0 0-152.768 210.048 0L750.656 583.296 540.672 583.296l0-114.56 210.048 0L750.72 411.392 581.952 411.392l123.008-123.008L663.68 247.104 512 398.784 360.384 247.104 319.104 288.384l123.008 123.008L273.28 411.392l0 57.28 210.048 0 0 114.56L273.28 583.232zM273.28 583.296\" p-id=\"2750\" /><path d=\"M512 64c247.04 0 448 200.96 448 448s-200.96 448-448 448-448-200.96-448-448S264.96 64 512 64M512 0C229.248 0 0 229.248 0 512s229.248 512 512 512 512-229.248 512-512S794.752 0 512 0L512 0z\" p-id=\"2751\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/recharge.svg
// module id = OWYW
// module chunks = 100